import { TranslationKey } from '@/shared/i18n';
import { PlanCategory } from '@/shared/types/Billing';

type PaywallPlanCopy = {
  descriptionKey: TranslationKey;
  featureKeys: TranslationKey[];
};

export const PAYWALL_PLAN_COPY: Partial<Record<PlanCategory, PaywallPlanCopy>> = {
  [PlanCategory.Business]: {
    descriptionKey: 'pricing.plan.businessDescription',
    featureKeys: [
      'pricing.plan.businessFeature1',
      'pricing.plan.businessFeature2',
      'pricing.plan.businessFeature3',
      'pricing.plan.unlimitedRecording',
    ],
  },
  [PlanCategory.Creator]: {
    descriptionKey: 'pricing.plan.creatorDescription',
    featureKeys: [
      'pricing.plan.creatorFeature1',
      'pricing.plan.creatorFeature2',
      'pricing.plan.creatorFeature3',
      'pricing.plan.unlimitedRecording',
    ],
  },
  [PlanCategory.CreatorPro]: {
    descriptionKey: 'pricing.plan.creatorProDescription',
    featureKeys: [
      'pricing.plan.creatorProFeature1',
      'pricing.plan.creatorProFeature2',
      'pricing.plan.creatorProFeature3',
      'pricing.plan.unlimitedRecording',
    ],
  },
};

export const ENTERPRISE_COPY: PaywallPlanCopy = {
  descriptionKey: 'pricing.plan.enterpriseDescription',
  featureKeys: [
    'pricing.plan.enterpriseFeature1',
    'pricing.plan.enterpriseFeature2',
    'pricing.plan.enterpriseFeature3',
    'pricing.plan.enterpriseFeature4',
    'pricing.plan.unlimitedRecording',
  ],
};
